<template>
  <div>
    <v-card-text style="color: black">
        <h4 class="mb-2">2. {{ $t("agenda.lblSelectSigner") }}</h4>
        <v-row
          no-gutters
          class="mb-2"
          v-for="(signer, index) in selectSignerList"
          :key="signer.id"
        >
          <v-col>
            <v-card class="mx-auto" outlined>
              <!-- <v-container fill-height fluid> -->
              <v-row
                no-gutters
                align="center"
                justify="space-between"
                class="mx-3 pa-3"
              >
                <v-col cols="5">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" style="font-size: 15px">
                        {{ `${index + 1}.` }}
                        <v-avatar
                          v-if="signer.email"
                          left
                          v-bind="attrs"
                          v-on="on"
                          size="24"
                        >
                          <v-img
                            v-if="signer.profilePhoto"
                            contain
                            :src="signer.profilePhoto"
                          ></v-img>
                          <v-img
                            v-else
                            contain
                            src="@/assets/images/NoPhotoIcon.png"
                          ></v-img>
                        </v-avatar>
                        <span
                          class="ml-2"
                          v-if="signer.firstName && signer.lastName"
                          >{{ `${signer.firstName} ${signer.lastName}` }}</span
                        >
                        <span class="ml-2" v-else>{{ signer.email }}</span>
                      </span>
                    </template>
                    <span> {{ signer.email }} </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2">
                  <signer-action
                    @onDelete="confirmDelete(signer.id)"
                    :upDisabled="index === 0"
                    :downDisabled="index === selectSignerList.length - 1"
                  ></signer-action>
                </v-col>
              </v-row>
              <!-- </v-container> -->
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="mr-2"
              color="primary"
              small
              text
              v-bind="attrs"
              v-on="on"
              @click="openSignerSelectDialog"
            >
              <v-icon small>mdi-plus</v-icon>
              <span>{{ $t("agenda.lblAddSigner") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("agenda.lblAddSigner") }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              class="mr-2"
              color="primaryDark"
              v-bind="attrs"
              v-on="on"
              @click="nextStep"
              :disabled="selectSignerList.length === 0"
              ><span>{{ $t("Next") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("Next") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              class="mr-2"
              color="secondary"
              v-bind="attrs"
              v-on="on"
              @click="onBack"
              ><span>{{ $t("Back") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("Back") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              color="secondary"
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnCancel") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnCancel") }} </span>
        </v-tooltip>
      </v-card-actions>
      <signer-select
        v-if="showSignerSelectDialog"
        v-model="showSignerSelectDialog"
        :signerList.sync="selectSignerList"
        :attendeesList="attendeesList"
        :label="$t('agenda.lblSigner')"
      >
      <template #heading>
          {{ $t('agenda.lblAddRemoveSigner') }}
        </template>
      </signer-select>
      <confirm-dialog ref="confirmDelete" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SignerAction from "./SignerAction.vue";
import SignerOptions from "./SignerOptions.vue";
import SignerSelect from "./SignerSelect.vue";

import ConfirmDialog from "../../ConfirmDialog.vue";
export default {
  components: {
    SignerAction,
    SignerOptions,
    SignerSelect,
    ConfirmDialog,
  },
  name: "AddSignerStep",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    attendeesList: Array,
    signerList: Array,
  },
  data() {
    return {
      selectSignerList: this.signerList ? this.signerList : [],
      showSignerSelectDialog: false,
      signLanguage: "ja",
    };
  },
  computed: {
    loaderText() {
      return this.$t("LoaderText");
    },
  },
  methods: {
    ...mapActions({
      sendMOMSignatureDocumentEmail: "agenda/sendMOMSignatureDocumentEmail",
    }),
    close,
    confirmDelete,
    onBack,
    nextStep,
    openSignerSelectDialog() {
      this.showSignerSelectDialog = true;
    },
  },
};
function nextStep(){
  this.$emit(
    "update:signerList",
    this.selectSignerList
  );
  this.$emit("nextStep", this.selectSignerList);
}

async function confirmDelete(id) {
  try {
    if (
      await this.$refs.confirmDelete.open(
        this.$t("agenda.hDeleteMessage"),
        this.$t("agenda.lblDeleteMessage")
      )
    ) {
      const findIndex = this.selectSignerList.findIndex(
        (signer) => signer.id === id
      );

      if (findIndex !== -1) {
        this.selectSignerList.splice(findIndex, 1);
        this.$emit(
          "update:signerList",
          this.selectSignerList
        );
      }
    }
  } catch (error) {
    this.Loaderloading = false;
  }
}


function onBack() {
  this.$emit("back");
  this.close();
}

function close() {
  this.$emit("close");
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>